import loadContentModule from './modules/Content.module';
import loadUrlModule from './modules/Url.module';
import loadFilterModule from './modules/FilterModule';
const loadContentTileListerModule = (initialData) => ({
    hasRouter: true,
    modules: [loadContentModule(initialData), loadUrlModule(initialData), loadFilterModule(initialData)],
});
export default loadContentTileListerModule;
